module.exports = __webpack_public_path__ + "img/sun-icon.67a7a0d0.png";